// video section homepage play button hide show and play pause video start

document.addEventListener("DOMContentLoaded", function () {
  const videoSection = document.querySelector(".video-section__media");
  if (!videoSection) return;

  const playButton = videoSection.querySelector(".deferred-media__poster-button");
  const iframe = videoSection.querySelector("iframe");
  const shopifyVideo = videoSection.querySelector("video");

  function toggleButton(show) {
    if (playButton) {
      playButton.style.display = show ? "flex" : "none";
    }
  }

  if (playButton) {
    playButton.addEventListener("click", function () {
      if (shopifyVideo) {
        shopifyVideo.play();
        toggleButton(false);
      } else if (iframe) {
        if (iframe.classList.contains("js-youtube")) {
          const youtubePlayer = new YT.Player(iframe, {
            events: {
              onReady: function (event) {
                event.target.playVideo();
              },
              onStateChange: function (event) {
                if (event.data === YT.PlayerState.PLAYING) {
                  toggleButton(false);
                } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                  toggleButton(true);
                }
              },
            },
          });
        } else if (iframe.classList.contains("js-vimeo")) {
          const vimeoPlayer = new Vimeo.Player(iframe);
          vimeoPlayer.play();
          vimeoPlayer.on("play", () => toggleButton(false));
          vimeoPlayer.on("pause", () => toggleButton(true));
          vimeoPlayer.on("ended", () => toggleButton(true));
        }
      }
    });
  }

  if (shopifyVideo) {
    shopifyVideo.addEventListener("play", () => toggleButton(false));
    shopifyVideo.addEventListener("pause", () => toggleButton(true));
    shopifyVideo.addEventListener("ended", () => toggleButton(true));
  }
});

// video section homepage play button hide show and play pause video end

// Header open menu toggle on menu hover start
 let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
    items.forEach(item => {
     item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
       item.querySelector("ul, .megamenu-image-block.mega_menu_2").addEventListener("mouseleave", () => {
         item.removeAttribute("open");
       });
       item.addEventListener("mouseleave", () => {
         item.removeAttribute("open");
       });
     });
    });
  }
// Header open menu toggle on menu hover end

// logo change 
document.addEventListener("DOMContentLoaded", function() {
    function toggleLogo() {
        var stickyHeader = document.querySelector("sticky-header");
        var indexLogo = document.querySelector(".index-page-logo");
        var otherLogo = document.querySelector(".other-pages-logo");

        if (!indexLogo || !otherLogo) return;

        if (stickyHeader && stickyHeader.classList.contains("transparent_header")) {
            indexLogo.style.display = "block";
            otherLogo.style.display = "none";
        } else {
            indexLogo.style.display = "none";
            otherLogo.style.display = "block";
        }
    }

    toggleLogo();
    document.addEventListener("scroll", toggleLogo);
});


document.addEventListener("DOMContentLoaded", function() {
    var addtocartbuttons = document.querySelectorAll("#custom-product-add");
    console.log(addtocartbuttons, "addtocartbuttons");

    if (addtocartbuttons.length) {
        addtocartbuttons.forEach((btn) => {
            btn.addEventListener("click", function(event) {
                event.preventDefault();
                var href = this.getAttribute("href");
              console.log("href >>> ",href);
              if (href == 'javascript:void(0);'){
                let productId = this.getAttribute("data-product-id");
                let sections = ['cart-drawer', 'cart-icon-bubble'];
                if (productId)
                {
                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {'Content-Type': 'application/json'},
                      body: JSON.stringify({
                          id: productId,
                          quantity: 1,
                          sections: sections
                      }),
                  })
                  .then((res) => res.json())
                  .then((response) => { 
                      const cartbtn = document.querySelector('#cart-icon-bubble');
                      const cartDrawer = document.querySelector('cart-drawer');
  
                      if (cartDrawer) {
                          cartDrawer.classList.remove('is-empty');
  
                          // Check if renderContents method exists
                          if (typeof cartDrawer.renderContents === "function") {
                              cartDrawer.renderContents(response);
                          }
                      }
  
                      // Check if upsellRecommended function exists before calling it
                      if (typeof upsellRecommended === "function") {
                          upsellRecommended();
                      }
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  });
                }
              }else{
                window.location.href = href;
              }
                
            });
        });
    }
});

// btn.addEventListener("click", function(event) {
//     let productId = this.getAttribute("data-product-id");
//     let href = this.getAttribute("href");

//     // Only prevent default and run fetch if productId is available
//     if (productId && href.includes('javascript:void(0)')) {
//         event.preventDefault();

//         let sections = ['cart-drawer', 'cart-icon-bubble'];

//         fetch(window.Shopify.routes.root + 'cart/add.js', {
//             method: 'POST',
//             headers: {'Content-Type': 'application/json'},
//             body: JSON.stringify({
//                 id: productId,
//                 quantity: 1,
//                 sections: sections
//             }),
//         })
//         .then((res) => res.json())
//         .then((response) => {
//             const cartDrawer = document.querySelector('cart-drawer');

//             if (cartDrawer) {
//                 cartDrawer.classList.remove('is-empty');

//                 if (typeof cartDrawer.renderContents === "function") {
//                     cartDrawer.renderContents(response);
//                 }
//             }

//             if (typeof upsellRecommended === "function") {
//                 upsellRecommended();
//             }
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
//     }
// });

/* accordion start */
document.addEventListener('DOMContentLoaded', function () {

  function faqAccordion() {
  const accoHeadings = document.querySelectorAll('.faq-accordian .acc-block-wrap .acco-head');

  accoHeadings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      const selectedContent = heading.nextElementSibling;
      const isActive = heading.classList.contains('active');

      // Close all
      accoHeadings.forEach(function (otherHeading) {
        const otherContent = otherHeading.nextElementSibling;
        otherHeading.classList.remove('active');
        otherContent.classList.remove('active');
      });

      // If it wasn't active before, open it
      if (!isActive) {
        heading.classList.add('active');
        selectedContent.classList.add('active');
      }
    });
  });
}


  faqAccordion();
});

/* accordion end */

